<template>
  <layout-stepper :key="current_step">
    <template #body>
      <div class="d-flex" v-if="!has_slug">
        <b-col class="col-6 text-start">
          <b-link @click="makeRedirect()" v-if="has_prev_step" class="link-back">
            <feather-icon icon="ChevronLeftIcon"></feather-icon>
            {{ $t('creator.previousStep') }}
          </b-link>
        </b-col>
      </div>
      <div>
        <step-organization v-if="current_step === 'organization'"/>
        <step-organization-search v-if="current_step === 'organization-search'"/>
        <step-title v-if="current_step === 'title-description'"/>
        <step-networks v-if="current_step === 'networks'"/>
        <step-cover-image v-if="current_step === 'cover-image'"/>
        <step-preview-card v-if="current_step === 'preview-card'"/>
        <step-location v-if="current_step === 'location'"/>
      </div>
    </template>
  </layout-stepper>
</template>

<script>
import {
  BLink,
  BCol,
} from 'bootstrap-vue';

import layoutStepper from '@/views/components/proposals/layoutStepper.vue';
import stepOrganization from './stepOrganization.vue';
import stepTitle from './stepTitle.vue';
import stepCoverImage from './stepCoverImage.vue';
import stepOrganizationSearch from './stepOrganizationSearch.vue';
import StepPreviewCard from './stepPreviewCard.vue';

export default {
  name: 'settingCastingCallDashboard',
  components: {
    BLink,
    BCol,
    stepOrganization,
    stepTitle,
    stepCoverImage,
    layoutStepper,
    stepOrganizationSearch,
    StepPreviewCard,
    stepLocation: () => import('./stepLocation.vue'),
    stepNetworks: () => import('./stepNetworks.vue'),
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    },
  },
  data() {
    return {
      has_prev_step: true,
      current_step: this.$route.params.step,
      steps: {},
    }
  },
  created() {
    this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true);
    this.getStep();
  },
  methods: {
    getStep() {
      this.steps = JSON.parse(localStorage.getItem('steps')) === null ? {} : JSON.parse(localStorage.getItem('steps'));
    },  
    makeRedirect() {
      if (this.current_step === 'organization-search') {
        const nav_white = document.getElementsByClassName('nav-hover-steps')[0];
        if (nav_white) nav_white.classList.add('d-none');
        this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
        this.$store.commit('appConfig/UPDATE_FOOTER_CONFIG', { type: 'static' });
        this.$router.push({ name: 'dashboard-analytics' });
        return;
      }

      const general_steps = {
        'organization': 'organization-search',
        'title-description': 'organization',
        'networks': 'title-description',
        'cover-image': 'location',
        'preview-card': 'cover-image',
        'description-casting-call': 'preview-card',
        'visibility': 'description-casting-call',
        'location': 'networks',
        'delivery-deadline': 'location',
        'tags': 'delivery-deadline',
        'attachment-files': 'tags',
        'compensation': 'attachment-files',
        'information-request': 'compensation'
      };

      if (general_steps[this.current_step]) {
        this.$router.push({ name: 'steps_casting_call', params: { step: general_steps[this.current_step] } });
      }
    },

  },
  watch: {
    '$route.params.step'(new_step) {
      this.current_step = new_step
      this.getStep();
    }
  }
}
</script>